import type { NavItem, SiteConfig } from '@/types'

import { siteImages } from '@/constants/assets'

/* The canonical address the site is published on. Change this one value and
   every canonical URL, sitemap entry and social preview follows. */
export const siteConfig: SiteConfig = {
    name: 'Capital Craft Construction',
    legalName: 'Capital Craft Construction Ltd',
    description: 'Extensions, loft conversions and structural alterations for period homes across South-East London and Kent. Fixed written quotations, one site manager, Building Control sign-off.',
    url: 'https://capitalcraftconstruction.co.uk',
    ogImage: siteImages.hero
}

export const contact = {
    phone: '020 8064 3301',
    phoneHref: 'tel:+442080643301',
    email: 'Info@capitalcraftconstruction.co.uk',
    emailHref: 'mailto:Info@capitalcraftconstruction.co.uk',
    /* Where the website sends the alert when someone submits the enquiry form.
       Never rendered on the site, server-side only. */
    enquiryInbox: 'info@capitalcraftconstruction.co.uk',
    locality: 'Blackheath',
    region: 'London',
    postalArea: 'SE3',
    country: 'GB',
    coverage: 'South-East London and Kent',
    hours: [
        { days: 'Monday to Friday', time: '08:00 - 18:00' },
        { days: 'Saturday', time: '08:00 - 13:00' },
        { days: 'Sunday', time: 'Closed' }
    ],
    openingSpec: [
        'Mo-Fr 08:00-18:00',
        'Sa 08:00-13:00'
    ]
}

/* Social and messaging. The WhatsApp link is a click-to-chat on the company
   number in full international form, which is what opens a real conversation
   on both mobile and desktop. Add `facebook` here once the page is confirmed
   and the footer renders it automatically. */
export const social = {
    instagramHandle: '@capitalcraftconstruction',
    instagram: 'https://www.instagram.com/capitalcraftconstruction/',
    whatsappHandle: '@capitalcraftconstruction',
    whatsapp: 'https://wa.me/442080643301',
    facebook: 'https://www.facebook.com/captialcraftconstruction'
}

export const primaryNav: NavItem[] = [
    { href: '/services', label: 'Services' },
    { href: '/projects', label: 'Projects' },
    { href: '/areas', label: 'Areas covered' },
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' }
]

/* Short, checkable assurances. No invented awards, no invented numbers. */
export const assurances = [
    'Structural calculations by a chartered engineer',
    'Building Control sign-off on every structural job',
    'Party Wall notices served on your behalf',
    'Fixed written quotation before we start'
]

export const processSteps = [
    {
        number: '01',
        title: 'Site visit and measure',
        body: 'We come to the property, take levels and dimensions, look at the drains, the roof line and the party walls, and tell you honestly what is and is not possible.'
    },
    {
        number: '02',
        title: 'Drawings and approvals',
        body: 'Our architectural technician and structural engineer produce the drawings and calculations. We submit for planning or permitted development, and handle Building Control and Party Wall notices.'
    },
    {
        number: '03',
        title: 'Fixed written quotation',
        body: 'A full specification priced line by line, with a start date and a programme. No provisional sums hiding the real cost, and no day rates that drift.'
    },
    {
        number: '04',
        title: 'On site',
        body: 'One site manager, one number to call. Weekly updates with photographs, a tidy site every evening, and a dust screen between the works and the rest of your home.'
    },
    {
        number: '05',
        title: 'Sign-off and aftercare',
        body: 'Building Control completion certificate, structural calculations and all guarantees handed over in one pack. We return at six months to check the finishes and settle anything that has moved.'
    }
]
